// TODO: Brauchen wir das noch?

// build string for submit when values within reference key list are changed
Array.from(document.querySelectorAll('.referenceKeyList input[type="text"]')).forEach((el) => {
    el.addEventListener('change', (e) => {
        const result = [];
        const input = document.querySelectorAll('.referenceKeyList input[readonly]');

        input.each(function(key, el) {
            const paramValue = el.value;

            result.push(paramValue + ':' + document.querySelector('#value_' + paramValue).value);
        });

        if (result.length > 0) {
            document.querySelector('input[name="referenceKeys"]').value = result.join(',');
        }
    });
});
